import React from 'react';
import PropTypes from 'prop-types';
import { getFullName } from 'utils/contact';
import { withStyles } from '@material-ui/styles';
import { secondary50, secondary200 } from 'themes/colors';
import cx from 'classnames';
import { Can } from 'utils/permissions';
import pencilIcon from 'icons/pencilIcon.svg';
import checkedIcon from 'icons/checkedIcon.svg';
import isEqual from 'lodash/isEqual';

const styles = theme => ({
  wrapper: {
    height: '3.5rem',
    color: theme.palette.secondary.text,
    backgroundColor: theme.palette.secondary['0'],
    fontSize: '0.875rem',
    border: 'none',
    borderBottom: `1px solid ${secondary200}`,
    width: '100%',
    '&:hover': {
      backgroundColor: secondary50,
      cursor: 'pointer',
      border: 'none',
    },
  },
  selected: {
    color: theme.palette.primary.main,
    backgroundColor: secondary50,
    border: 'none',
  },
  contactName: {
    display: 'flex',
    textAlign: 'left',
    fontSize: '0.75rem',
    fontWeight: '600',
    lineHeight: '1.25rem',
  },
  contactEmail: {
    textAlign: 'left',
    fontSize: '0.75rem',
    fontWeight: '500',
    lineHeight: '1.25rem',
  },
  pencilIcon: {
    marginRight: '0.375rem',
  },
  checkedIcon: {
    marginRight: '0.375rem',
  },
});

const ContactItem = ({
  contact, onClick, classes, selected, initialValues, formValues,
}) => (
  <button className={cx(classes.wrapper, selected ? classes.selected : '')} onClick={onClick}>
    <div className={classes.contactName}>
      {
        (!isEqual(initialValues, formValues) && selected &&
        <img src={pencilIcon} alt="pencil_icon" className={classes.pencilIcon} />) ||
        (contact.customized &&
        <img src={checkedIcon} alt="checked_icon" className={classes.checkedIcon} />)
      }

      {getFullName(contact)}
    </div>
    <Can I="see" a="Contact Email"><div className={classes.contactEmail}>{contact.email}</div></Can>
  </button>
);

ContactItem.propTypes = {
  contact: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    email: PropTypes.string,
    customized: PropTypes.bool,
  }).isRequired,
  selected: PropTypes.bool,
  classes: PropTypes.element.isRequired,
  onClick: PropTypes.func.isRequired,
  formValues: PropTypes.shape({}).isRequired,
  initialValues: PropTypes.shape({}).isRequired,
};

ContactItem.defaultProps = {
  selected: false,
};

export default withStyles(styles)(ContactItem);
